import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import RouteMapLineSelector from './RouteMapLineSelector'
import MainRouteMap from './MainRouteMap';
import IzuminoRouteMap from './IzuminoRouteMap'
import ShinyokohamaRouteMap from './ShinyokohamaRouteMap'
import LineSwipable from '../LineSwipable'
import { Link } from 'react-router-dom'
import { navigateToInApp } from '../../utils/URLSchemeHelper'

const RouteMapDetail = (props) => {
  const { themeName, appVersion } = props
  const intl = useIntl()
  const { lineName } = useParams()

  useEffect(() => {
    // componentDidMount equivalent
  }, [])

  const renderMap = () => {
    const { locale } = intl

    switch (lineName) {
      case 'main':
        return <MainRouteMap locale={locale} themeName={themeName} />
      case 'izumino':
        return <IzuminoRouteMap locale={locale} themeName={themeName} />
      case 'for_tokyu':
        return <ShinyokohamaRouteMap locale={locale} themeName={themeName} />
      default:
        return (<div>Not Found</div>)
    }
  }

  const { locale } = intl

  const handleClickTrainPositions = (event) => {
    navigateToInApp(event, `/lines/${lineName}/trains`, appVersion, '&close=true')
  }
  
  return(
    <LineSwipable currentLineName={lineName} target="route_map">
      <RouteMapLineSelector lineName={lineName} type="route_map" themeName={themeName} />

      {renderMap()}

      <footer className={`c-Footer is_routemap is_${locale}`}>
        <div className="c-Footer-inner">
          <Link to={`/lines/${lineName}/trains`} className={`c-Footer-button c-Footer-button-trainposition-${themeName}`} onClick={handleClickTrainPositions}></Link>
          <Link to={`/route_map/kinds`} className={`c-Footer-button c-Footer-button-hanrei-${themeName}`}></Link>
        </div>
      </footer>
    </LineSwipable>
  )
}

RouteMapDetail.propTypes = {
  themeName: PropTypes.string.isRequired,
  appVersion: PropTypes.string,
}

export default RouteMapDetail
